import { User } from 'types/user';
import { JobSeekingStatus } from 'types/types';
import preferencesAPI from 'api/preferencesAPI';

export const renewActiveJobSeekingStatus = async (
  user: User,
  setJobSeekingStatus: (status: { status: string; updated_at: string }) => void
) => {
  const updatedPreference = {
    job_seeking_status: JobSeekingStatus.OPEN_TO_WORK_AND_MATCHES,
    job_seeking_status_updated_at: new Date().toISOString(),
  };
  const response = await preferencesAPI.update(user?.id, updatedPreference);
  setJobSeekingStatus({
    status: response.job_seeking_status,
    updated_at: response.job_seeking_status_updated_at,
  });
  return response;
};
